var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLuckyChoiceBackground1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.859 0.224365L135.661 8.01174L137.859 9.39338L139.999 4.74607L137.859 0.224365Z",
    fill: "#F59E1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6632 129.972L53.4651 137.76L55.6632 139.141L57.8034 134.494L55.6632 129.972Z",
    fill: "#B31414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M109.071 76.8777L113.21 78.4983L113.005 73.5494L110.234 70.906L109.071 76.8777Z",
    fill: "#019F6A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.100464 17.3032L4.24003 18.9238L4.03503 13.9749L1.26392 11.3315L0.100464 17.3032Z",
    fill: "#F59E1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3708 68.1368L15.1727 75.9241L17.3708 77.3058L19.511 72.6585L17.3708 68.1368Z",
    fill: "#6E94F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7782 15.0423L74.9178 16.6629L74.7128 11.714L71.9416 9.07066L70.7782 15.0423Z",
    fill: "#019F6A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyChoiceBackground1);
export default __webpack_public_path__ + "static/media/lucky-choice-background-1.a7f75041364753f438a59f0c8ce01113.svg";
export { ForwardRef as ReactComponent };